import { MakeCall } from './createMakeCall';

export default (makeCall: MakeCall) => (userId: 'me' | number, data: {}) =>
  makeCall<undefined>('POST', `/api/v2/user/${userId}/search`, {
    data,
  });
